import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import Card from "../components/ui/Card";
import Button from "../components/ui/Button";
import { resolveLegacyUrl } from "../lib/legacy";
import { getSessionToken } from "../lib/auth";

function SignatureGatewayPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = Boolean(getSessionToken());

  const target = useMemo(() => {
    return resolveLegacyUrl(location.pathname || "/", {
      search: location.search || "",
      hash: location.hash || ""
    });
  }, [location.hash, location.pathname, location.search]);

  const continueToSigning = () => {
    window.location.assign(target);
  };

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    let rowLevelDocId = "";
    try {
      const rowLevelRaw = localStorage.getItem("rowlevel");
      const rowLevel = rowLevelRaw ? JSON.parse(rowLevelRaw) : null;
      rowLevelDocId = String(rowLevel?.id || rowLevel?.objectId || "").trim();
    } catch (error) {
      rowLevelDocId = "";
    }

    if (rowLevelDocId) {
      navigate(`/pdfRequestFiles/${rowLevelDocId}`, { replace: true });
      return;
    }

    navigate("/report/4Hhwbp482K", { replace: true });
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen bg-app-sand px-4 py-10">
      <div className="mx-auto max-w-2xl animate-fade-up">
        <Card>
          <p className="ui-kicker">{t("new-ui.signature-gateway.kicker", { defaultValue: "Signature flow compatibility" })}</p>
          <h1 className="ui-title mt-2 text-xl">{t("new-ui.signature-gateway.title", { defaultValue: "You are entering the secure signing flow" })}</h1>
          <p className="ui-copy mt-3">
            {t("new-ui.signature-gateway.description", {
              defaultValue:
                "This route keeps full compatibility with the production signing flow."
            })}
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <Button onClick={continueToSigning}>{t("new-ui.signature-gateway.continue", { defaultValue: "Continue to signing" })}</Button>
            <Button variant="ghost" onClick={() => window.history.back()}>
              {t("new-ui.common.go-back", { defaultValue: "Go back" })}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default SignatureGatewayPage;
